import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { ContractTerminationConfirmAction } from '../../../../common/types'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'
import Success from 'components/Success'

export const ConfirmSuccess: React.FC = () => {
  const { t } = useTranslation(['common', 'contractModification'])
  const [params] = useSearchParams()

  const action = params.get('action') as ContractTerminationConfirmAction

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name={
            action === ContractTerminationConfirmAction.ACCEPT
              ? 'house-bye'
              : 'house-confused'
          }
          alt={t('common:alt.illustration')}
          className="-ml-2"
        />
      }
      heading={
        action === ContractTerminationConfirmAction.ACCEPT
          ? t('contractModification:headings.thankYou')
          : t('contractModification:headings.confirmationRejected')
      }
      text={
        action === ContractTerminationConfirmAction.ACCEPT
          ? t('contractModification:texts.confirmationAccepted')
          : undefined
      }
    />
  )
}
